import React from 'react'
import PropTypes from 'prop-types'
import { InputForm } from 'components/Form/components'
import { Button } from 'ui-components/Button'
import {
  Search,
  ExpandLess,
  ExpandMore,
  Remove,
} from '@material-ui/icons'
import { ASC, DESC, DEFAULT } from 'constants/sortableList'
import {
  FormContainer,
  Filters,
  ButtonContainer,
  SortOptions,
  SortOption,
} from './styles'

export default function SearchForm(props) {
  const {
    filters,
    onSearch,
    onChange,
    onSort,
  } = props

  const handleSubmit = (evt) => {
    evt.preventDefault()
    onSearch()
  }

  const handleChange = (evt) => {
    const { name, value } = evt.target
    onChange(name, value)
  }

  const handleSelectOrder = (order) => {
    let sort = ''
    if (order) {
      sort = filters.sort === ASC ? DESC : ASC
    }

    onSort({ order, sort })
  }

  const renderIcon = (name) => {
    if (name === DEFAULT) return null
    if (name !== filters.order) return <Remove />

    if (filters.sort === ASC) {
      return (
        <ExpandLess />
      )
    }

    return (
      <ExpandMore />
    )
  }

  const colorSort = (name) => {
    if (name === DEFAULT && !filters.sort) {
      return 'primary'
    }

    return name === filters.order ? 'primary' : 'default'
  }

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Filters>
        <InputForm
          fullWidth
          label="Nome, documento ou email"
          name="search"
          value={filters.search}
          onChange={handleChange}
        />
      </Filters>
      <ButtonContainer>
        <Button
          type="submit"
          buttonType="icon"
          size="small"
        >
          <Search />
        </Button>
      </ButtonContainer>
      <SortOptions>
        <span>
          Ordenar:
        </span>
        <SortOption
          size="small"
          label="Código"
          variant="outlined"
          onClick={() => handleSelectOrder('code')}
          deleteIcon={renderIcon('code')}
          onDelete={() => {}}
          color={colorSort('code')}
        />
        <SortOption
          size="small"
          label="Nome"
          variant="outlined"
          onClick={() => handleSelectOrder('name')}
          deleteIcon={renderIcon('name')}
          onDelete={() => {}}
          color={colorSort('name')}
        />
        <SortOption
          size="small"
          label="Padrão"
          variant="outlined"
          onClick={() => handleSelectOrder('')}
          deleteIcon={renderIcon(DEFAULT)}
          onDelete={() => {}}
          color={colorSort(DEFAULT)}
        />
      </SortOptions>
    </FormContainer>
  )
}

SearchForm.propTypes = {
  onSearch: PropTypes.func.isRequired,
  filters: PropTypes.objectOf(PropTypes.any),
  onChange: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
}

SearchForm.defaultProps = {
  filters: {},
}
